/**
 * Tipi TypeScript per il modulo Magazzino
 */

// Tipi articolo
export const TIPI_ARTICOLO = ['materia_prima', 'semilavorato', 'prodotto_finito'] as const
export type TipoArticolo = typeof TIPI_ARTICOLO[number]

export const TIPI_ARTICOLO_LABELS: Record<TipoArticolo, string> = {
  materia_prima: 'Materia Prima',
  semilavorato: 'Semilavorato',
  prodotto_finito: 'Prodotto Finito',
}

// Tipi movimento
export const TIPI_MOVIMENTO = ['carico', 'scarico', 'rettifica'] as const
export type TipoMovimento = typeof TIPI_MOVIMENTO[number]

export const TIPI_MOVIMENTO_LABELS: Record<TipoMovimento, string> = {
  carico: 'Carico',
  scarico: 'Scarico',
  rettifica: 'Rettifica',
}

// Fornitore
export interface Fornitore {
  id: string
  codice: string
  ragione_sociale: string
  p_iva: string | null
  telefono: string | null
  email: string | null
  via: string | null
  citta: string | null
  cap: string | null
  provincia: string | null
  note: string | null
  categoria_merceologica: string | null
  codice_ateco: string | null
  ruolo: string | null
  attivo: boolean
  created_at: string
}

export interface FornitoreForm {
  codice: string
  ragione_sociale: string
  p_iva: string
  telefono: string
  email: string
  via: string
  citta: string
  cap: string
  provincia: string
  note: string
  categoria_merceologica: string
  codice_ateco: string
  ruolo: string
  attivo: boolean
}

// Articolo
export interface Articolo {
  id: string
  codice: string
  descrizione: string
  tipo: TipoArticolo
  unita_misura: string
  prezzo_acquisto: number
  fornitore: string | null
  fornitore_id: string | null
  fornitore_nome: string | null
  scorta_minima: number
  giacenza_attuale: number
  listino_id: string | null
  ubicazione: string | null
  note: string | null
  attivo: boolean
  has_distinta: boolean
  created_at: string
}

export interface ArticoloForm {
  codice: string
  descrizione: string
  tipo: string
  unita_misura: string
  prezzo_acquisto: string
  fornitore: string
  fornitore_id: string
  scorta_minima: string
  giacenza_attuale: string
  listino_id: string
  ubicazione: string
  note: string
  attivo: boolean
}

// Distinta Base
export interface DistintaBase {
  id: string
  articolo_id: string
  articolo_codice: string
  articolo_descrizione: string
  codice: string
  descrizione: string | null
  note: string | null
  attivo: boolean
  componenti_count: number
  ore_produzione: number
  costo_orario_produzione: number
  produzione_interna: boolean
  created_at: string
}

export interface DistintaBaseDetail extends DistintaBase {
  componenti: Componente[]
  lavorazioni: Lavorazione[]
}

export interface Componente {
  id: string
  distinta_id: string
  articolo_componente_id: string
  articolo_componente_codice: string
  articolo_componente_descrizione: string
  articolo_componente_um: string
  giacenza_componente: number
  quantita: number
  note: string | null
  ordine: number
  created_at: string
}

export interface ComponenteForm {
  articolo_componente_id: string
  quantita: string
  note: string
  ordine: number
}

export interface DistintaBaseForm {
  articolo_id: string
  codice: string
  descrizione: string
  note: string
}

// Lavorazioni
export interface Lavorazione {
  id: string
  distinta_id: string
  descrizione: string
  ore_previste: number
  personale_id: string | null
  personale_nome: string | null
  costo_orario: number
  note: string | null
  ordine: number
  created_at: string
}

export interface LavorazioneForm {
  descrizione: string
  ore_previste: string
  personale_id: string
  costo_orario: string
  note: string
  ordine: number
}

// Personale (minimal for dropdown)
export interface PersonaleOption {
  id: string
  nome: string
  cognome: string
  ruolo: string | null
}

// Movimenti
export interface Movimento {
  id: string
  articolo_id: string
  articolo_codice: string
  articolo_descrizione: string
  tipo: TipoMovimento
  quantita: number
  causale: string | null
  riferimento_tipo: string | null
  riferimento_id: string | null
  note: string | null
  eseguito_da: string | null
  created_at: string
}

export interface MovimentoForm {
  articolo_id: string
  tipo: string
  quantita: string
  causale: string
  note: string
}

// Giacenze
export type StatoScorta = 'ok' | 'sotto_scorta' | 'esaurito'

export interface Giacenza {
  id: string
  codice: string
  descrizione: string
  tipo: TipoArticolo
  unita_misura: string
  giacenza_attuale: number
  prenotato: number
  giacenza_disponibile: number
  scorta_minima: number
  stato_scorta: StatoScorta
  ubicazione: string | null
  fornitore: string | null
}

// Prenotazioni
export interface PrenotazioneArticolo {
  id: string
  offerta_id: string
  numero_offerta: string
  cliente_nome: string
  costo_id: string
  quantita: number
  costo_unitario: number | null
  disponibilita_ok: boolean
  created_at: string
}
